import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CupomFiscal } from '@/pages/cupom-fiscal';

export const Route = createFileRoute('/a/cupom-fiscal/')({
    component: CupomFiscal,
    validateSearch: z.object({ idpk: z.number().optional() }),
});
